import { render, staticRenderFns } from "./ChatSupervisorHelpAlertCount.vue?vue&type=template&id=6a2324f8"
import script from "./ChatSupervisorHelpAlertCount.vue?vue&type=script&lang=js"
export * from "./ChatSupervisorHelpAlertCount.vue?vue&type=script&lang=js"
import style0 from "./ChatSupervisorHelpAlertCount.vue?vue&type=style&index=0&id=6a2324f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports